'use strict';

var React = require('react');
var Picture_index = require('./Picture/index.js');
require('./Product.styles-df71ba35.js');
var Product_ProductImage_index = require('./Product/ProductImage/index.js');
require('./Product/ProductInfoBox/index.js');
require('./Product/PriceRenderer/index.js');
var tslib_es6 = require('./tslib.es6-13d783d6.js');
var breakPoints_index = require('./breakPoints/index.js');
var types = require('./types-169d4b99.js');
var utils_image_index = require('./utils/image/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var getPLPImageSizeInfo = function (screenWidth) {
    var screenHeight = Math.round((screenWidth * 4) / 3);
    var horizontalPadding = Math.round(screenWidth / 12.5);
    var verticalPadding = Math.round(screenHeight / 5.681818182);
    return {
        padding: {
            top: verticalPadding,
            right: horizontalPadding,
            bottom: verticalPadding,
            left: horizontalPadding,
        },
        size: {
            width: screenWidth,
            height: screenHeight,
        },
    };
};
var getPLPHeroImageSizeInfo = function (screenWidth, imageTag) {
    var heightDivisor = imageTag === types.ProductImageTag.DETAIL ? 4 / 3 : 1.03380281690141;
    var paddingMultiplier = imageTag === types.ProductImageTag.DETAIL ? 0 : 1;
    var screenHeight = Math.round(screenWidth * heightDivisor);
    var horizontalPadding = Math.round(screenWidth / 12.5);
    var verticalPadding = Math.round(screenHeight / 7.3529411765);
    return {
        padding: {
            top: verticalPadding * paddingMultiplier,
            right: horizontalPadding * paddingMultiplier,
            bottom: Math.round(verticalPadding / 2) * paddingMultiplier,
            left: horizontalPadding * paddingMultiplier,
        },
        size: {
            width: screenWidth,
            height: screenHeight,
        },
    };
};

var addedPaddingTags = [types.ProductImageTag.REGULAR, types.ProductImageTag.INFO_GRAPHIC];
var excludeTrimmingTags = new Set([types.ProductImageTag.DETAIL, types.ProductImageTag.SIZE_RELATION]);
var ImageWidths;
(function (ImageWidths) {
    ImageWidths[ImageWidths["PLP_DESKTOP_TABLET_LOW_DENSITY"] = 375] = "PLP_DESKTOP_TABLET_LOW_DENSITY";
    ImageWidths[ImageWidths["PLP_DESKTOP_TABLET_HIGH_DENSITY"] = 750] = "PLP_DESKTOP_TABLET_HIGH_DENSITY";
    ImageWidths[ImageWidths["PLP_DESKTOP_WIDE_SCREEN_LOW_DENSITY"] = 465] = "PLP_DESKTOP_WIDE_SCREEN_LOW_DENSITY";
    ImageWidths[ImageWidths["PLP_DESKTOP_WIDE_SCREEN_HIGH_DENSITY"] = 930] = "PLP_DESKTOP_WIDE_SCREEN_HIGH_DENSITY";
    ImageWidths[ImageWidths["PLP_MOBILE_LOW_DENSITY"] = 228] = "PLP_MOBILE_LOW_DENSITY";
    ImageWidths[ImageWidths["PLP_MOBILE_HIGH_DENSITY"] = 456] = "PLP_MOBILE_HIGH_DENSITY";
    ImageWidths[ImageWidths["PLP_IPHONE_X"] = 375] = "PLP_IPHONE_X";
    ImageWidths[ImageWidths["PLP_HERO_IPHONE_X"] = 355] = "PLP_HERO_IPHONE_X";
    ImageWidths[ImageWidths["PLP_HERO_MOBILE_LOW_DENSITY"] = 460] = "PLP_HERO_MOBILE_LOW_DENSITY";
    ImageWidths[ImageWidths["PLP_HERO_MOBILE_HIGH_DENSITY"] = 920] = "PLP_HERO_MOBILE_HIGH_DENSITY";
})(ImageWidths || (ImageWidths = {}));
var getShortPath = function (src) {
    var key = 'simple';
    return "" + key + (src.split(key)[1] || '');
};
var useImageTagFormatter = function (tag, staticCmsHost, isImageServiceProductImageEnabled, options
) {
    if (options === void 0) { options = { webP: false, padding: true, isTrimmed: true }; }
    var _a = options.webP, webP = _a === void 0 ? false : _a, _b = options.padding, padding = _b === void 0 ? true : _b, _c = options.isTrimmed, isTrimmed = _c === void 0 ? true : _c, _d = options.isLimited, isLimited = _d === void 0 ? false : _d;
    var resizeConfigurations = {
        padding: padding,
        removeText: isImageServiceProductImageEnabled,
        isTrimmed: isTrimmed && !excludeTrimmingTags.has(tag),
        isLimited: isLimited,
    };
    var isImageWithPadding = addedPaddingTags.includes(tag);
    var formatImage = function (src, imageWidth, imageSizeInfo) {
        var path = src;
        if (path.startsWith('http')) {
            path = getShortPath(path);
        }
        var desiredImageWidth = imageWidth;
        var sizeInfo = imageSizeInfo || utils_image_index.getImageSizeInfo(desiredImageWidth);
        var paddingSize = isImageWithPadding ? sizeInfo.padding : undefined;
        var imageDimension = tslib_es6.__assign(tslib_es6.__assign({}, sizeInfo.size), { paddingSize: paddingSize });
        var webpSrc = utils_image_index.preFormatImage(path, staticCmsHost, tslib_es6.__assign(tslib_es6.__assign(tslib_es6.__assign({}, resizeConfigurations), imageDimension), { webP: webP }));
        var jpegSrc = utils_image_index.preFormatImage(path, staticCmsHost, tslib_es6.__assign(tslib_es6.__assign({}, resizeConfigurations), imageDimension));
        return { webpSrc: webpSrc, jpegSrc: jpegSrc };
    };
    return formatImage;
};

var useGetImageSources = function (src, tag, staticCmsHost, isHero, options
) {
    var formatter = useImageTagFormatter(tag, staticCmsHost, false, options);
    var _a = formatter(src, ImageWidths.PLP_IPHONE_X, isHero
        ? getPLPHeroImageSizeInfo(ImageWidths.PLP_HERO_IPHONE_X, tag)
        : getPLPImageSizeInfo(ImageWidths.PLP_IPHONE_X)), iphoneXSrcWebp = _a.webpSrc, iphoneXSrcJpeg = _a.jpegSrc;
    var _b = formatter(src, ImageWidths.PLP_MOBILE_LOW_DENSITY, isHero
        ? getPLPHeroImageSizeInfo(ImageWidths.PLP_HERO_MOBILE_LOW_DENSITY, tag)
        : getPLPImageSizeInfo(ImageWidths.PLP_MOBILE_LOW_DENSITY)), mobileSrcWebp = _b.webpSrc, mobileSrcJpeg = _b.jpegSrc;
    var _c = formatter(src, ImageWidths.PLP_MOBILE_HIGH_DENSITY, isHero
        ? getPLPHeroImageSizeInfo(ImageWidths.PLP_HERO_MOBILE_HIGH_DENSITY, tag)
        : getPLPImageSizeInfo(ImageWidths.PLP_MOBILE_HIGH_DENSITY)), mobileSrcWebp2xDpi = _c.webpSrc, mobileSrcJpeg2xDpi = _c.jpegSrc;
    var _d = formatter(src, ImageWidths.PLP_DESKTOP_TABLET_LOW_DENSITY, getPLPImageSizeInfo(ImageWidths.PLP_DESKTOP_TABLET_LOW_DENSITY)), desktopTabletWebpSrc = _d.webpSrc, desktopTabletJpegSrc = _d.jpegSrc;
    var _e = formatter(src, ImageWidths.PLP_DESKTOP_TABLET_HIGH_DENSITY, getPLPImageSizeInfo(ImageWidths.PLP_DESKTOP_TABLET_HIGH_DENSITY)), desktopTabletWebp2xDpiSrc = _e.webpSrc, desktopTabletJpeg2xDpiSrc = _e.jpegSrc;
    var _f = formatter(src, ImageWidths.PLP_DESKTOP_WIDE_SCREEN_LOW_DENSITY, getPLPImageSizeInfo(ImageWidths.PLP_DESKTOP_WIDE_SCREEN_LOW_DENSITY)), desktopWideScreenWebpSrc = _f.webpSrc, desktopWideScreenJpegSrc = _f.jpegSrc;
    var _g = formatter(src, ImageWidths.PLP_DESKTOP_WIDE_SCREEN_HIGH_DENSITY, getPLPImageSizeInfo(ImageWidths.PLP_DESKTOP_WIDE_SCREEN_HIGH_DENSITY)), desktopWideScreenWebp2xDpiSrc = _g.webpSrc, desktopWideScreenJpeg2xDpiSrc = _g.jpegSrc;
    var tabletSource2xDpi = Picture_index.jpegBackupSource({
        media: breakPoints_index.getMediaStringValue('breakpointTablet', true),
        url: mobileSrcWebp2xDpi,
        value: 2,
        format: Picture_index.ImageFormat.WEBP,
    }, mobileSrcJpeg2xDpi);
    var sources = tslib_es6.__spreadArrays(Picture_index.jpegBackupSource({
        media: breakPoints_index.iphoneXMediaQuery,
        url: iphoneXSrcWebp,
        value: 1,
        format: Picture_index.ImageFormat.WEBP,
    }, iphoneXSrcJpeg), Picture_index.jpegBackupSource({
        media: breakPoints_index.getMediaStringValue('breakpointTablet', true),
        url: mobileSrcWebp,
        value: 1,
        format: Picture_index.ImageFormat.WEBP,
    }, mobileSrcJpeg), tabletSource2xDpi, Picture_index.jpegBackupSource({
        media: breakPoints_index.getMediaStringValue('breakpointTablet'),
        url: desktopTabletWebpSrc,
        value: 1,
        format: Picture_index.ImageFormat.WEBP,
    }, desktopTabletJpegSrc), Picture_index.jpegBackupSource({
        media: breakPoints_index.getMediaStringValue('breakpointTablet'),
        url: desktopTabletWebp2xDpiSrc,
        value: 2,
        format: Picture_index.ImageFormat.WEBP,
    }, desktopTabletJpeg2xDpiSrc), Picture_index.jpegBackupSource({
        media: breakPoints_index.getMediaStringValue('breakpointSemiWideScreens'),
        url: desktopWideScreenWebpSrc,
        value: 1,
        format: Picture_index.ImageFormat.WEBP,
    }, desktopWideScreenJpegSrc), Picture_index.jpegBackupSource({
        media: breakPoints_index.getMediaStringValue('breakpointSemiWideScreens'),
        url: desktopWideScreenWebp2xDpiSrc,
        value: 2,
        format: Picture_index.ImageFormat.WEBP,
    }, desktopWideScreenJpeg2xDpiSrc));
    return [sources, tabletSource2xDpi];
};

var logImageErrorWarning = function (url, tag, logger, customData) {
    logger.warn("[" + tag + "] Image with src - \"" + url + "\" failed to load", customData);
};
var imageLoadErrorFunction = function (e, logger, tag, customData
) {
    logImageErrorWarning(e.currentTarget.currentSrc, tag, logger, customData);
};
var ProductTileImage = function (_a) {
    var product = _a.product, isHero = _a.isHero, imageConfigs = _a.imageConfigs;
    var altTag = product.altTag, simpleSku = product.simpleSku, name = product.name, productImage = product.productImage, bestSellingImage = product.bestSellingImage;
    var loading = imageConfigs.loading, testId = imageConfigs.testId, className = imageConfigs.className, logger = imageConfigs.logger, staticCmsHost = imageConfigs.staticCmsHost;
    var imageData = (bestSellingImage === null || bestSellingImage === void 0 ? void 0 : bestSellingImage.path) ? bestSellingImage : productImage;
    var tag = imageData.tag, seoSrc = imageData.seoUrl, path = imageData.path;
    var errorFunction = function (e) {
        var customData = {
            product: name,
            simpleSku: simpleSku,
        };
        return imageLoadErrorFunction(e, logger, 'PLP', customData);
    };
    var _b = useGetImageSources(path, tag, staticCmsHost, isHero), sources = _b[0], fallbackSource = _b[1];
    var seoUrl = seoSrc;
    if (!seoSrc.includes('/t_default.plp_seo')) {
        seoUrl = fallbackSource[0].url;
    }
    var fallback = { url: seoUrl, alt: altTag };
    return (React__default['default'].createElement(Product_ProductImage_index.ProductImage, { className: className, "data-testid": testId },
        React__default['default'].createElement(Picture_index['default'], { sources: sources, loading: loading, fallback: fallback, errorFunction: errorFunction })));
};

exports.ProductTileImage = ProductTileImage;
exports.imageLoadErrorFunction = imageLoadErrorFunction;
exports.logImageErrorWarning = logImageErrorWarning;
exports.useGetImageSources = useGetImageSources;
//# sourceMappingURL=index-792fa1ce.js.map
